import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import { OfferCard } from "./OfferCard";
import { BillNegotiatorCard } from "./BillNegotiatorCard";
import { HotelReservationCard } from "../hotelReservation";
import { FlightReservationCard } from "../flightReservation";
import PurchasedProductCard from "../purchasedProduct/PurchasedProductCard";
import UserSubscriptionCard from "../userSubscription/UserSubscriptionCard";
import { HotelReservationWithRefundProcess } from "@/types/hotelReservation";
import { FlightDelayWithRefundProcess } from "@/types/flightReservation";
import { PurchasedProductWithRefundProcess } from "@/types/purchasedProduct";
import { UserSubscriptionWithRefundProcess } from "@/types/userSubscription";
import AdgemOfferCard from "../adgem/OfferCard";
import { Offer } from "@/types/offer";
import Icons from "@/assets/icons";

type Props = {
  item: any;
  onHide?: (_id: string) => void;
  onClaim?: (_id: string) => void;
  onStartMonitoring?: () => void;
};

const FeedItemRenderer: React.FC<Props> = ({
  item,
  onHide,
  onClaim,
  onStartMonitoring,
}) => {
  const itemId = item?.id || item?._id;

  const renderCloseButton = () => {
    if (!itemId || !onHide) return null;
    return (
      <TouchableOpacity
        style={styles.closeButton}
        onPress={() => onHide(itemId)}
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      >
        <Icons.Close width={20} height={20} />
      </TouchableOpacity>
    );
  };

  if (item.type === "billNegotiator") {
    return (
      <View style={styles.container}>
        {renderCloseButton()}
        <BillNegotiatorCard />
      </View>
    );
  }

  if (item.type === "hotelReservation") {
    return (
      <View style={styles.container}>
        {renderCloseButton()}
        <HotelReservationCard
          reservation={item as HotelReservationWithRefundProcess}
        />
      </View>
    );
  }

  if (item.type === "purchasedProduct") {
    return (
      <View style={styles.container}>
        {renderCloseButton()}
        <PurchasedProductCard
          product={item as PurchasedProductWithRefundProcess}
        />
      </View>
    );
  }

  if (item.type === "userSubscription") {
    return (
      <View style={styles.container}>
        {renderCloseButton()}
        <UserSubscriptionCard
          subscription={item as UserSubscriptionWithRefundProcess}
        />
      </View>
    );
  }

  if (item.type === "flightReservation") {
    return (
      <View style={styles.container}>
        {renderCloseButton()}
        <FlightReservationCard
          reservation={item as FlightDelayWithRefundProcess}
        />
      </View>
    );
  }

  if (item.type === "adgemOffer") {
    return (
      <View style={styles.container}>
        {renderCloseButton()}
        <AdgemOfferCard offer={item as Offer} />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {renderCloseButton()}
      <OfferCard
        data={item}
        onHide={() => itemId && onHide?.(itemId)}
        onClaim={() => onClaim?.(item)}
        onStartMonitoring={onStartMonitoring}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    top: 16,
    right: 24,
    zIndex: 10,
  },
});

export default FeedItemRenderer;
